angular.module('zc.zenclerkS')

  .controller('ZcsMailMagUrlModalController', ZcsMailMagUrlModalController);


ZcsMailMagUrlModalController.$inject = ['$uibModalInstance', 'Campaign', 'campaign', 'project'];
function ZcsMailMagUrlModalController($uibModalInstance, Campaign, campaign, project) {
  const vm = this;
  vm.campaign = campaign;
  vm.project = project;
  vm.landingPage = project.base_url; // set to project base_url by default
  vm.getLandingPageUrlWithParameter = getLandingPageUrlWithParameter;

  function getLandingPageUrlWithParameter() {
    return Campaign.showsAllUrl(vm.landingPage, vm.campaign);
  }

  vm.close = () => {
    $uibModalInstance.close();
  };
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/zenclerk_s/sites/campaigns/mail_mag_url_modal.controller.js